import { useMediaQuery } from 'usehooks-ts';

import { DesktopView } from './pages/views/desktop-view';
import { MobileView } from './pages/views/mobile-view';

export const DailyQuestsPage = () => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  return <>{isMobile ? <MobileView /> : <DesktopView />}</>;
};
